import React from "react";
import RevealSection from "../RevealSection";

const CARDS = [
  {
    icon: "📅",
    title: "Is this job still active?",
    body: "GuMi checks when the posting was listed and whether it's still in the ATS feed, so you know your real application window before you apply.",
    tag: "FRESHNESS",
  },
  {
    icon: "🎯",
    title: "Does your resume match?",
    body: "Your skills, seniority, and domain are scored against what the JD actually asks for. See exactly what you're missing.",
    tag: "FIT SCORE",
  },
  {
    icon: "📞",
    title: "What are your callback odds?",
    body: "Your odds of hearing back, based on how your resume lines up with this posting. It's a read on the match. The employer still makes the call.",
    tag: "CALLBACK ODDS",
  },
  {
    icon: "🏢",
    title: "Is this company stable?",
    body: "How stable the company looks, based on the posting and general knowledge of the company. Worth knowing before you put weeks into interviews.",
    tag: "COMPANY HEALTH",
  },
  {
    icon: "📈",
    title: "Is hiring steady or shaky?",
    body: "Hiring volatility, based on the posting and general knowledge of the company. Where we track them, you also see roles the company recently posted or removed.",
    tag: "HIRING VOLATILITY",
  },
];

export const Signals = () => {
  return (
    <section
      id="signals"
      data-testid="signals-section"
      style={{ background: "#f5f4f0", padding: "80px 20px" }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <p
          className="font-body"
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "#1D9E75",
            textAlign: "center",
            marginBottom: 12,
          }}
        >
          WHAT GUMI TELLS YOU
        </p>

        <RevealSection as="div">
          <h2
            className="font-heading"
            style={{ fontSize: 28, fontWeight: 700, textAlign: "center", marginBottom: 48 }}
          >
            5 signals. One honest answer.
          </h2>
        </RevealSection>

        <div className="landing-card-grid" style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 20 }}>
          {CARDS.map((c, i) => (
            <RevealSection key={c.tag} delay={i + 1} className="signal-card-hover landing-card">
              <div
                data-testid={`signal-card-${c.tag.toLowerCase().replace(/\s+/g, "-")}`}
                style={{
                  background: "white",
                  borderRadius: 16,
                  padding: "28px 24px",
                  border: "0.5px solid #e5e5e3",
                  height: "100%",
                }}
              >
                <span style={{ fontSize: 32, display: "block" }} aria-hidden="true">{c.icon}</span>
                <h3
                  className="font-heading"
                  style={{ marginTop: 16, fontSize: 19, fontWeight: 700, color: "#1a1a18" }}
                >
                  {c.title}
                </h3>
                <p
                  className="font-body"
                  style={{ marginTop: 10, fontSize: 16, color: "#5f5e5a", lineHeight: 1.6 }}
                >
                  {c.body}
                </p>
                <span
                  className="font-body"
                  style={{
                    display: "inline-block",
                    marginTop: 16,
                    background: "#E1F5EE",
                    color: "#1D9E75",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    padding: "4px 10px",
                    borderRadius: 999,
                  }}
                >
                  {c.tag}
                </span>
              </div>
            </RevealSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Signals;
